module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "odiv"
    }
  }, [_c('p', {
    staticClass: "p1",
    staticStyle: {
      "border-bottom": "1px solid #e7e7e7"
    }
  }, [_vm._v("审核")]), _vm._v(" "), _c('div', {
    staticClass: "dela"
  }, [_c('el-row', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_vm._v("入库单号："), _c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.detailData.id),
      callback: function($$v) {
        _vm.$set(_vm.detailData, "id", $$v)
      },
      expression: "detailData.id"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_vm._v("入库日期：\n                    "), _c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.detailData.date),
      callback: function($$v) {
        _vm.$set(_vm.detailData, "date", $$v)
      },
      expression: "detailData.date"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_vm._v("供应商：\n                    "), _c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.detailData.supplier),
      callback: function($$v) {
        _vm.$set(_vm.detailData, "supplier", $$v)
      },
      expression: "detailData.supplier"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_vm._v("制单人：\n                    "), _c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.detailData.username),
      callback: function($$v) {
        _vm.$set(_vm.detailData, "username", $$v)
      },
      expression: "detailData.username"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_vm._v("备注：\n                    "), _c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.detailData.remarks),
      callback: function($$v) {
        _vm.$set(_vm.detailData, "remarks", $$v)
      },
      expression: "detailData.remarks"
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "98%",
      "margin-left": "18px"
    },
    attrs: {
      "data": _vm.itemList,
      "stripe": "",
      "row-key": "rowkey",
      "header-cell-style": _vm.tableHeaderColor
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "value",
      "label": "药品名称",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unit",
      "label": "单位"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inNumber",
      "label": "数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "retailPrice",
      "label": "零售价(￥)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "costPrice",
      "label": "成本价(￥)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "costPriceTotal",
      "label": "成本合计(￥)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "batchNumber",
      "label": "批号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "effectiveDates",
      "label": "有效期"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 20px"
    }
  }, [_vm._l((_vm.url), function(item) {
    return _c('div', {
      staticStyle: {
        "width": "200px",
        "height": "150px",
        "float": "left"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "height": "100%"
      },
      attrs: {
        "src": item.url,
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.openpic(item.url)
        }
      }
    })])
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "查看图片",
      "visible": _vm.dialogVisible,
      "width": "60%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.pic,
      "alt": ""
    }
  })])], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "50px 20px",
      "clear": "both"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.audit
    }
  }, [_vm._v("审核")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info",
      "plain": ""
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("返回")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-113860c9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/pharmacy/audit.vue
// module id = 999
// module chunks = 2